import { type TierType } from "@src/appV2/redesign/Tiers/api/schema";
import { GoldTierHeaderSection } from "@src/appV2/redesign/Tiers/HeaderSection/GoldTierHeaderSection";
import { LimitedTierHeaderSection } from "@src/appV2/redesign/Tiers/HeaderSection/LimitedTierHeaderSection";
import { SilverTierHeaderSection } from "@src/appV2/redesign/Tiers/HeaderSection/SilverTierHeaderSection";

interface HeaderSectionProps {
  workerTier: TierType;
  tierLastChangedAt: Date;
}

export function HeaderSection(props: HeaderSectionProps) {
  const { workerTier } = props;

  // eslint-disable-next-line default-case
  switch (workerTier) {
    case "GOLD": {
      return <GoldTierHeaderSection {...props} />;
    }

    case "SILVER": {
      return <SilverTierHeaderSection />;
    }

    case "LIMITED": {
      return <LimitedTierHeaderSection />;
    }
  }
}
